import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  ONLINE_STORE_FACEBOOK_MODAL_OPENED,
  ONLINE_STORE_FACEBOOK_MODAL_CLOSED,
  ONLINE_STORE_CLOSE_OUTLET_MODAL,
  ONLINE_STORE_SHOW_FACEBOOK_DOMAIN_VERIFICATION_MODAL,
  ONLINE_STORE_CLOSE_FACEBOOK_DOMAIN_VERIFICATION_MODAL,
  ONLINE_STORE_ON_CHANGE_FACEBOOK_DOMAIN_VERIFICATION,
} from 'actions/onlineStore/constants';

const isModalOpened = createReducer(false, {
  [ONLINE_STORE_FACEBOOK_MODAL_OPENED]: () => true,
  [ONLINE_STORE_FACEBOOK_MODAL_CLOSED]: () => false,
  [ONLINE_STORE_CLOSE_OUTLET_MODAL]: () => false,
});

const isDomainVerificationModalOpened = createReducer(false, {
  [ONLINE_STORE_SHOW_FACEBOOK_DOMAIN_VERIFICATION_MODAL]: () => true,
  [ONLINE_STORE_CLOSE_FACEBOOK_DOMAIN_VERIFICATION_MODAL]: () => false,
});

const selectedShop = createReducer(null, {
  [ONLINE_STORE_SHOW_FACEBOOK_DOMAIN_VERIFICATION_MODAL]: (
    draft,
    { payload }
  ) => payload.shop,
  [ONLINE_STORE_CLOSE_FACEBOOK_DOMAIN_VERIFICATION_MODAL]: () => null,
});

const domainVerificationError = createReducer(null, {
  [ONLINE_STORE_CLOSE_FACEBOOK_DOMAIN_VERIFICATION_MODAL]: () => null,
  [ONLINE_STORE_ON_CHANGE_FACEBOOK_DOMAIN_VERIFICATION]: (draft, { payload }) =>
    payload.error,
});

const domainVerificationStep = createReducer(1, {
  [ONLINE_STORE_CLOSE_FACEBOOK_DOMAIN_VERIFICATION_MODAL]: () => 1,
  [ONLINE_STORE_ON_CHANGE_FACEBOOK_DOMAIN_VERIFICATION]: (draft, { payload }) =>
    payload.step,
});

export default combineReducers({
  isDomainVerificationModalOpened,
  isModalOpened,
  selectedShop,
  domainVerificationError,
  domainVerificationStep,
});
